// extracted by mini-css-extract-plugin
export var printerCard = "_bj-1";
export var printerCardConfigured = "_bj-2";
export var printerCardError = "_bj-3";
export var printerCardsContainer = "_bj-0";
export var printerIcon = "_bj-8";
export var printerIconConfigured = "_bj-5";
export var printerIconContainer = "_bj-4";
export var printerIconError = "_bj-6";
export var printerIconUnconfigured = "_bj-7";
export var workstationsTableCard = "_bj-9";